<template>
  <div class="vehicleModifyDialog">
    <popup v-if="activated">
      <template #title>가입 차량 정보</template>

      <template #content>
        <VehicleInputForm
            ref="vehicleInputForm"
            v-bind:item="item"
            @validated="setValidated"
        />
      </template>

      <template #button>
        <span class="button">
          <a v-if="validated" class="fCol1" @click="updateSubsc()">확인</a>
          <a v-else class="fColDisabled">확인</a>
        </span>
      </template>
    </popup>
  </div>
</template>

<script>
import axios from "axios";
import {api} from "../../../../api";
import Popup from "../../../../components/Popup/Popup";
import VehicleInputForm from "../../components/VehicleInputForm";
import SubscApplyVehicleConst from "../../components/SubscApplyVehicleConst";


export default {
  components: {
    Popup,
    VehicleInputForm,
  },

  props: {
    user: Object,
    subsc: Object,
  },

  data(){
    return{
      item: SubscApplyVehicleConst.ITEM,
      activated: false,
      validated: true,
    }
  },

  watch: {
  },

  methods: {
    setItem(){
      this.item.customerName.val = this.user.name;
      this.item.model.val = this.subsc.options.vehicleData.model.type;
      this.item.modelYear.val = this.subsc.options.vehicleData.model.year;
      this.item.vehicleNumId.val = this.subsc.options.vehicleData.num_id;
      this.item.vehicleRegDate.val = this.subsc.options.vehicleData.date_reg;
      this.item.vehicleRegNum.val = this.subsc.options.vehicleData.num_reg;

      this.item.customerName.disabled = true;
      this.item.vehicleNumId.disabled = true;
    },

    setValidated(validated){
      this.validated = validated;
    },

    open(){
      this.setItem();
      this.activated = true;
    },

    updateSubsc(){
      this.subsc.options.vehicleData.model.type = this.item.model.val;
      this.subsc.options.vehicleData.model.year = this.item.modelYear.val;
      this.subsc.options.vehicleData.date_reg  = this.item.vehicleRegDate.val;
      this.subsc.options.vehicleData.num_reg = this.item.vehicleRegNum.val;

      axios.put(`${api.subscs}/${this.subsc.id}`, {options: this.subsc.options})
          .then(() => {
            this.close();
          })
          .catch((error) => {
            if(error.response.status === 401) {
              this.$store.commit('setPopup401', true);
            } else {
              this.alertRoute(this.errorMsg(error));
            }
          });
    },

    close() {
      this.$emit("closed");
    },
  },
}


</script>

<style>
.vehicleModifyDialog .layerPop [class*='Wrap']>.btnBox>span{
  width: 100%;
}
</style>